import { distance } from 'fastest-levenshtein';

export default function getEditDistanceRatio(
  original: string,
  edited: string,
): number {
  if (original === edited) return 0;

  return distance(original, edited) / Math.max(original.length, edited.length);
}
